import CommonConstants from '../constants/CommonConstants';
import ApiConstants from '../constants/ApiConstants';
import Utils from '../util';

let AccountActions = {
  loginError: function (error) {
    return {
      error,
      type: CommonConstants.LOGIN_ERROR,
    };
  },

  loginSuccess: function (response) {
    return {
      response,
      type: CommonConstants.LOGIN_SUCCESS,
    };
  },

  login: function (data, cb) {
    let _apiBody = 'grant_type=password&username=' + data.username + '&password=' + data.password;
    return (dispatch) => {
      fetch(ApiConstants.getApiPath() + 'oauth2/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization:
            'Basic ' +
            Utils.btoa(ApiConstants.getApiClient().client_id + ':' + ApiConstants.getApiClient().client_secret),
        },
        body: _apiBody,
      })
        .then((res) => {
          if (res.ok) {
            res.json().then((response) => {
              dispatch(this.loginSuccess(response));
              cb(response);
            });
          } else {
            let _error = {
              status: res.status,
              error: res.statusText,
            };
            dispatch(this.loginError(_error));
            cb(_error);
          }
        })
        .catch((error) => {
          console.log('error');
          console.error(error);
          dispatch(this.loginError(error));
          cb(error);
        });
    };
  },

  signup: function (data, cb) {
    return (dispatch) => {
      fetch(ApiConstants.getApiPath() + 'api/v1/users', {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Basic ' +
            Utils.btoa(ApiConstants.getApiClient().client_id + ':' + ApiConstants.getApiClient().client_secret),
        },
      })
        .then((res) => {
          if (res.ok) {
            res.json().then((response) => {
              fetch(ApiConstants.getWebhook_bedaddy(), {
                method: 'POST',
                body: JSON.stringify({ text: `${data.firstname} ${data.lastname} s'est inscrit à BeDaddy` }),
                headers: {
                  'Content-Type': 'application/json',
                },
                mode: 'no-cors',
              });
              cb(response);
            });
          } else {
            res.json().then((response) => {
              let _error = {
                status: response.status,
                error: response.errors,
              };
              cb(_error);
            });
          }
        })
        .catch((error) => {
          console.log('error');
          console.error(error);
          cb(error);
        });
    };
  },

  getUserDetailsError: function (error) {
    return {
      error,
      type: CommonConstants.GET_USER_DETAILS_ERROR,
    };
  },

  getUserDetailsSuccess: function (response) {
    return {
      response,
      type: CommonConstants.GET_USER_DETAILS_SUCCESS,
    };
  },

  getUserDetails: function (cb) {
    let token = localStorage.getItem('accessToken');
    let user_id = localStorage.getItem('userId');

    return (dispatch) => {
      fetch(`${ApiConstants.getApiPath()}api/v1/users/${user_id}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'Accept-Language': 'fr-FR',
        },
      })
        .then((res) => {
          if (res.ok) {
            res.json().then((response) => {
              dispatch(this.getUserDetailsSuccess(response));
              cb(response);
            });
          } else {
            let _error = {
              status: res.status,
              error: res.statusText,
            };
            dispatch(this.getUserDetailsError(_error));
            cb(_error);
          }
        })
        .catch((error) => {
          console.log('error');
          console.error(error);
          dispatch(this.getUserDetailsError(error));
          cb(error);
        });
    };
  },

  getStripeCustomerError: function (error) {
    return {
      error,
      type: CommonConstants.GET_STRIPE_CUSTOMER_ERROR,
    };
  },

  getStripeCustomerSuccess: function (response) {
    return {
      response,
      type: CommonConstants.GET_STRIPE_CUSTOMER_SUCCESS,
    };
  },

  getStripeCustomer: function (cb) {
    const token = localStorage.getItem('accessToken');
    const user_id = localStorage.getItem('userId');

    return (dispatch) => {
      fetch(`${ApiConstants.getApiPath()}api/v1/users/${user_id}/stripe-customer`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'Accept-Language': 'fr-FR',
        },
      })
        .then((res) => {
          if (res.ok) {
            res.json().then((response) => {
              dispatch(this.getStripeCustomerSuccess(response));
              cb(response);
            });
          } else {
            let _error = {
              status: res.status,
              error: res.statusText,
            };
            dispatch(this.getStripeCustomerError(_error));
            cb(_error);
          }
        })
        .catch((error) => {
          console.log('error');
          console.error(error);
          dispatch(this.getStripeCustomerError(error));
          cb(error);
        });
    };
  },

  getStripeCheckoutSessionError: function (error) {
    return {
      error,
      type: CommonConstants.GET_STRIPE_CHECKOUT_SESSION_ERROR,
    };
  },

  getStripeCheckoutSessionSuccess: function (response) {
    return {
      response,
      type: CommonConstants.GET_STRIPE_CHECKOUT_SESSION_SUCCESS,
    };
  },

  getStripeCheckoutSession: function (cb) {
    const token = localStorage.getItem('accessToken');
    const user_id = localStorage.getItem('userId');

    return (dispatch) => {
      fetch(`${ApiConstants.getApiPath()}api/v1/users/${user_id}/stripe-checkout-session`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'Accept-Language': 'fr-FR',
        },
      })
        .then((res) => {
          if (res.ok) {
            res.json().then((response) => {
              dispatch(this.getStripeCheckoutSessionSuccess(response));
              cb(response);
            });
          } else {
            let _error = {
              status: res.status,
              error: res.statusText,
            };
            dispatch(this.getStripeCheckoutSessionError(_error));
            cb(_error);
          }
        })
        .catch((error) => {
          console.log('error');
          console.error(error);
          dispatch(this.getStripeCheckoutSessionError(error));
          cb(error);
        });
    };
  },

  createCustomerPortalSession: function (cb) {
    const token = localStorage.getItem('accessToken');
    const user_id = localStorage.getItem('userId');
    if (!user_id) {
      alert(`Une erreur est survenue`, `Veuillez réessayer un peu plus tard`);
    }

    return (dispatch) => {
      fetch(`${ApiConstants.getApiPath()}api/v1/users/${user_id}/customer-portal-session`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'Accept-Language': 'fr-FR',
        },
      })
        .then((res) => {
          if (res.ok) {
            res.json().then((response) => {
              cb(response);
            });
          } else {
            let _error = {
              status: res.status,
              error: res.statusText,
            };
            cb(_error);
          }
        })
        .catch((error) => {
          console.log('error');
          console.error(error);
          alert(`Une erreur est survenue`, `Veuillez réessayer un peu plus tard`);
          cb(error);
        });
    };
  },

  postStripeCheckoutSessionError: function (error) {
    return {
      error,
      type: CommonConstants.POST_STRIPE_CHECKOUT_SESSION_ERROR,
    };
  },

  postStripeCheckoutSessionSuccess: function (response) {
    return {
      response,
      type: CommonConstants.POST_STRIPE_CHECKOUT_SESSION_SUCCESS,
    };
  },
  postStripeCheckoutSession: function (body, cb) {
    console.log(body);
    const token = localStorage.getItem('accessToken');
    const user_id = localStorage.getItem('userId');

    return (dispatch) => {
      fetch(`${ApiConstants.getApiPath()}api/v1/users/${user_id}/stripe-checkout-session`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'Accept-Language': 'fr-FR',
        },
      })
        .then((res) => {
          if (res.ok) {
            res.json().then((response) => {
              dispatch(this.postStripeCheckoutSessionSuccess(response));
              cb(response);
            });
          } else {
            let _error = {
              status: res.status,
              error: res.statusText,
            };
            dispatch(this.postStripeCheckoutSessionError(_error));
            cb(_error);
          }
        })
        .catch((error) => {
          console.log('error');
          console.error(error);
          dispatch(this.postStripeCheckoutSessionError(error));
          cb(error);
        });
    };
  },

  subscribeToRenewalError: function (error) {
    return {
      error,
      type: CommonConstants.SUBSCRIBE_TO_RENEWAL_ERROR,
    };
  },

  subscribeToRenewalSuccess: function (response) {
    return {
      response,
      type: CommonConstants.SUBSCRIBE_TO_RENEWAL_SUCCESS,
    };
  },

  subscribeToRenewal: function (cb) {
    const token = localStorage.getItem('accessToken');
    const user_id = localStorage.getItem('userId');

    return (dispatch) => {
      fetch(`${ApiConstants.getApiPath()}api/v1/users/${user_id}/stripe-renewal-subscription`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'Accept-Language': 'fr-FR',
        },
      })
        .then((res) => {
          if (res.ok) {
            cb(res);
          } else {
            let _error = {
              status: res.status,
              error: res.statusText,
            };
            dispatch(this.subscribeToRenewalError(_error));
            cb(_error);
          }
        })
        .catch((error) => {
          console.log('error');
          console.error(error);
          dispatch(this.subscribeToRenewalError(error));
          cb(error);
        });
    };
  },

  cancelSubscriptionError: function (error) {
    return {
      error,
      type: CommonConstants.CANCEL_SUBSCRIPTION_ERROR,
    };
  },

  cancelSubscriptionSuccess: function (response) {
    return {
      response,
      type: CommonConstants.CANCEL_SUBSCRIPTION_SUCCESS,
    };
  },

  cancelSubscription: function (cb) {
    const token = localStorage.getItem('accessToken');
    const user_id = localStorage.getItem('userId');

    return (dispatch) => {
      fetch(`${ApiConstants.getApiPath()}api/v1/users/${user_id}/stripe-cancel-subscription`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          'Accept-Language': 'fr-FR',
        },
      })
        .then((res) => {
          if (res.ok) {
            cb(res);
          } else {
            let _error = {
              status: res.status,
              error: res.statusText,
            };
            dispatch(this.subscribeToRenewalError(_error));
            cb(_error);
          }
        })
        .catch((error) => {
          console.error('Error canceling subscription:', error);
          dispatch(this.cancelSubscriptionError(error));
          cb(error);
        });
    };
  },

  updateUserDataError: function (error) {
    return {
      error,
      type: CommonConstants.UPDATE_USER_DATA_ERROR,
    };
  },

  updateUserDataSuccess: function (response) {
    return {
      response,
      type: CommonConstants.UPDATE_USER_DATA_SUCCESS,
    };
  },

  updateUserData: function (data, cb) {
    let token = localStorage.getItem('accessToken');
    let user_id = localStorage.getItem('userId');

    return (dispatch) => {
      fetch(`${ApiConstants.getApiPath()}api/v1/users/${user_id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      })
        .then((res) => {
          if (res.ok) {
            res.json().then((response) => {
              dispatch(this.updateUserDataSuccess(data));
              cb(response);
            });
          } else {
            let _error = {
              status: res.status,
              error: res.statusText,
            };
            dispatch(this.updateUserDataError(_error));
            cb(_error);
          }
        })
        .catch((error) => {
          console.log('error');
          console.error(error);
          dispatch(this.updateUserDataError(error));
          cb(error);
        });
    };
  },

  postEmailToken: function (email_token, cb) {
    let token = localStorage.getItem('accessToken');
    let user_id = localStorage.getItem('userId');
    return (dispatch) => {
      fetch(`${ApiConstants.getApiPath()}api/v1/users/${user_id}/email-token/${email_token}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })
        .then((res) => {
          if (res.ok) {
            res.json().then((response) => {
              cb(response);
            });
          } else {
            let _error = {
              status: res.status,
              error: res.statusText,
            };
            cb(_error);
          }
        })
        .catch((error) => {
          console.log('error');
          console.error(error);
          cb(error);
        });
    };
  },

  resetEmail: function (token, password, cb) {
    let _apiBody = 'token=' + token + '&password=' + password;
    return (dispatch) => {
      fetch(ApiConstants.getApiPath() + 'api/v1/users/password/reset', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization:
            'Basic ' +
            Utils.btoa(ApiConstants.getApiClient().client_id + ':' + ApiConstants.getApiClient().client_secret),
        },
        body: _apiBody,
      })
        .then((res) => {
          if (res.ok) {
            res.json().then((response) => {
              cb(response);
            });
          } else {
            let _error = {
              status: res.status,
              error: res.statusText,
            };
            cb(_error);
          }
        })
        .catch((error) => {
          console.log('error');
          console.error(error);
          cb(error);
        });
    };
  },
};

export default AccountActions;



// WEBPACK FOOTER //
// ./actions/AccountActions.js